import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import { SERVER_URL } from '../ConstantsEN';
import { AgeGregorian_EndPoint, AgeHijri_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import DatePicker from "react-multi-date-picker";
import { Button, FormControlLabel, Radio } from "@mui/material";
import arabic from "react-date-object/calendars/arabic";
import arabic_ar from "react-date-object/locales/arabic_en";
import SharedHelmet from "../Helmet";
const TITLE = 'Gregorian Age Calculator - Calculate Your Age Precisely - Age Calculator';
const DESCRIPTION = 'Calculate age based on the Gregorian date of birth by entering the birthdate in either Gregorian or Hijri calendar - Use the Gregorian Age Calculator to easily convert dates into precise ages.';
const KEYWORDS = 'Gregorian Age Calculator, Convert Date to Age, Precise Age Calculator, Gregorian Calendar Age, Convert Date to Years, Gregorian Birthdate Calculator, Professional Age Calculator, Calculate Age Precisely, Birthdate to Actual Age, Calculate Persons Age in Gregorian Calendar, Calculate Age in Gregorian Calendar';
const OG_URL = 'https://do-calculate.com/calculator/en/agegregorian/';
const apiEndpointGregorian = `${SERVER_URL}/${AgeGregorian_EndPoint}`;
const apiEndpointHijri = `${SERVER_URL}/${AgeHijri_EndPoint}`;
function AgeCalculatorGregorian() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [convertedValue, setConvertedValue] = useState("gregorian");
  const handleConversionValueChange = (newConversionType) => {
    setConvertedValue(newConversionType);
    setIsLoading(false);
    setError(null);
    setStatusCode(null);
    setDateOfBirthGregorian("");
    setAgeGregorian(null);
    setAgeHijri(null);
    setValueHijri("");
  };
  const [dateOfBirthGregorian, setDateOfBirthGregorian] = useState("");
  const [ageGregorian, setAgeGregorian] = useState(null);
  const handleDateChangeGregorian = (event) => {
    setDateOfBirthGregorian(event.target.value);
  };
  const calculateAgeGregorian = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpointGregorian, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ dateOfBirth: dateOfBirthGregorian }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setAgeGregorian(data.age);
        setError(null);
      } else {
        setAgeGregorian(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  const [ageHijri, setAgeHijri] = useState(null);
  const [valueHijri, setValueHijri] = useState("");
  const calculateAgeHijri = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpointHijri, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ dateOfBirth: valueHijri.format("YYYY-MM-DD") }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setAgeHijri(data.age);
        setError(null);
      } else {
        setAgeHijri(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div>
        <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px', }}>
            <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                Calculate age based on the Gregorian date of birth by entering the birthdate in either Gregorian or Hijri calendar - Use the Gregorian Age Calculator to easily convert dates into precise ages. The calculator will determine the age in years, months, days, hours, minutes, and seconds.
                <br/>              </div>
              <br />
            </div>
            <hr />
            <MobileUnderCalAds/>
            <div className="row">
              <div
                className="form-group d-flex align-items-center"
                style={{
                  columnGap: "25px",
                  margin: "5px 15px 35px 0",
                }}
              >
                <b>
                  <label >Date Type:</label>
                </b>
                <div style={{ marginRight: "30px" }}>
                  <FormControlLabel
                    value="gregorian"
                    id="gregorianConversion"
                    name="conversionValue"
                    control={
                      <Radio
                        color="success"
                        checked={convertedValue === "gregorian"}
                        onChange={() =>
                          handleConversionValueChange("gregorian")
                        }
                      />
                    }
                    label="Gregorian"
                    labelPlacement="start"
                  />
                  <FormControlLabel
                    value="hijri"
                    id="hijriConversion"
                    name="conversionValue"
                    control={
                      <Radio
                        color="success"
                        value="hijri"
                        checked={convertedValue === "hijri"}
                        onChange={() => handleConversionValueChange("hijri")}
                      />
                    }
                    label="Hijri"
                    labelPlacement="start"
                  />
                </div>
              </div>
            </div>
            {convertedValue === "gregorian" ? (
              <div className="row">
                <div className="col">
                  <label htmlFor="dateOfBirth" style={{ fontSize: "16px" }}>
                    Enter your birth date in the Gregorian calendar
                  </label>
                </div>
                <div className="col">
                  <div className="form-group">
                    <input
                      type="date"
                      id="dateOfBirth"
                      value={dateOfBirthGregorian}
                      onChange={handleDateChangeGregorian}
                      className="form-control"
                      lang="ar"
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col">
                  <label htmlFor="hijriDatePicker" style={{ fontSize: "16px" }}>
                    Enter your birth date in the Hijri calendar
                  </label>
                </div>
                <div className="col">
                  <div className="form-group">
                    <DatePicker
                      value={valueHijri}
                      id="hijriDatePicker"
                      calendar={arabic}
                      locale={arabic_ar}
                      onChange={setValueHijri}
                      style={{ padding: "17px 10px" }}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col text-center">
                <br />
                <Button
                  variant="contained"
                  color="success"

                  onClick={
                    convertedValue === "gregorian"
                      ? calculateAgeGregorian
                      : calculateAgeHijri
                  }
                  sx={{ mb: "5px" }}
                >
                  Calculate

                </Button>
                <br />
              </div>
              <hr />
              <div className="row">
                <RelatedLinks />
                <br />
                <hr />
              </div>
              <div className="row">
                <div className="col">
                  <br />
                  {statusCode === 400 && (
                    <div className="alert alert-warning">
                      <b>
                        <u>Error occurred:</u>
                      </b>{" "}
                      Please enter a valid birth date.
                    </div>
                  )}
                  {ageGregorian && (
                    <div>
                      <br />
                      <div
                        style={{
                          backgroundColor: "#D1E7DD",
                          borderColor: "#c3e6cb",
                          color: "#155724",
                          padding: "15px",
                          marginBottom: "20px",
                          borderRadius: "4px",
                        }}
                      >
                        {" "}
                        <label>
                          <b> Your age is: </b>
                          {ageGregorian.years} years, {ageGregorian.months} months,{" "}
                          {ageGregorian.days} days, {ageGregorian.hours} hours,{" "}
                          {ageGregorian.minutes} minutes, {ageGregorian.seconds} seconds
                        </label>
                      </div>
                    </div>
                  )}
                  {ageHijri && (
                    <div>
                      <br />
                      <div
                        style={{
                          backgroundColor: "#D1E7DD",
                          borderColor: "#c3e6cb",
                          color: "#155724",
                          padding: "15px",
                          marginBottom: "20px",
                          borderRadius: "4px",
                        }}
                      >
                        {" "}
                        <label>
                          <b> Your age is: </b>
                          {ageHijri.years} years, {ageHijri.months} months,{" "}
                          {ageHijri.days} days, {ageHijri.hours} hours,{" "}
                          {ageHijri.minutes} minutes, {ageHijri.seconds} seconds
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col" >
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={CalculatorsType.humanCalculators}></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }} >
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Deeper Understanding of Age in Gregorian Calendar and Precise Calculation Using Calculators</div>
              <div className="info-section-body">
                <u><h2 style={{ fontSize: '16px' }}>Age in Gregorian Calendar: A Comprehensive Guide to Accurately Calculate Age According to the Gregorian Calendar</h2></u>
                <br />
                <p>
                  Age is an important concept in a person's life and can be estimated in various ways depending on different cultures and traditions. Among these methods is calculating age in the Gregorian calendar, which relies on the time system used by the Gregorian calendar. This type of calculation allows for precise conversion of dates into actual age and provides accurate results that contribute to a deeper understanding of the time a person has experienced.
                </p>
                <u><h2 style={{ fontSize: '16px' }}>Calculating Age in the Gregorian Calendar and Using Precise Calculators</h2></u>
                <p>
                  Calculating age in the Gregorian calendar is based on converting a person's actual birthdate into an exact number of years and days. This type of calculation is useful in various contexts, such as accurately estimating a person's age for multiple purposes, including reflecting on the past or planning for the future.
                </p>
                <u><h2 style={{ fontSize: '16px' }}>Deeper Understanding of Age in Gregorian Calendar and Using Precise Calculators for Conversion</h2></u>
                <p>
                  In a world filled with time and dates, age serves as a crucial measure of an individual's experience and journey in life. Age can be estimated in multiple ways, one of which is calculating age in the Gregorian calendar, which relies on the time system used in the Gregorian calendar. This type of calculation allows individuals to convert their birthdate into actual age with precision and detail.
                </p>
                <p>
                  The use of the Gregorian calendar to calculate a person's age dates back to Western and Christian history. The Gregorian calendar is based on the Gregorian calendar system, which was established in 1582 by Pope Gregory XIII.
                </p>
                <p>
                  In the Gregorian calendar, a year consists of 365 days, except for leap years, which contain an additional day in February. This calendar was adopted to align more accurately with Earth's orbit around the sun.
                </p>
                <p>
                  A person's age can be calculated in different ways in various cultures. This calculator is based on the most common age system. In this system, age increases on a person's birthday. For example, a person who has lived for 3 years and 11 months is considered to be 3 years old, and their age will increase to 4 on their next birthday in a month. Most Western countries use this age system.
                </p>
                <p>
                  In some cultures, age is expressed by counting years with or without including the current year. For example, a person who is 20 years old is the same age as another person who is in their 21st year of life. In some traditional Chinese age systems, individuals are considered to be 1 year old at birth and their age increases at the traditional Chinese New Year rather than on their birthdays. For example, if a child is born just one day before the traditional Chinese New Year, they will be 2 years old after two days, even though it's only their second day of life.
                </p>
                <p>
                  You can use this professional age calculator to convert dates into age in detail, taking into account the Gregorian calendar. You'll be able to accurately convert your birthdate into actual age and benefit from calculations based on the Gregorian calendar. Whether you need to calculate age in the Gregorian calendar or convert dates into years according to the Gregorian calendar, this accurate calculator provides you with the optimal solution.
                </p>
                <p>
                  A person's age in the Gregorian calendar depends on their birthdate and the current date. Age can be calculated in years, months, days, hours, minutes, and seconds.
                </p>
                <p>
                  However, it should be noted that the precise age in the Gregorian calendar depends on the current time and the Gregorian calendar date at the moment the code is executed. If the code is executed at a specific time, it will provide you with the current age based on that date.
                </p>
                <p>
                  For example, if today is May 22, 2023, and the birthdate is January 1, 2000, the age will be calculated based on these time differences.
                </p>
              </div>
            </div>
          </div>
          <br />
          <u><h3>Frequently Asked Questions</h3></u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>What is the Gregorian Age?</h3>
              </div>
              <div className="info-section-body">
                The Gregorian age is the method we use to measure a person's age based on their birthdate according to the monthly and yearly Gregorian calendar.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>How can I calculate the Gregorian age?</h3>
              </div>
              <div className="info-section-body">
                You can easily calculate the Gregorian age using the well-known rules of the Gregorian calendar. Start by knowing the person's birthdate and then calculate the number of years between that date and the current day. Consider the months and days as well.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>Is there a calculator for calculating the Gregorian age?</h3>
              </div>
              <div className="info-section-body">
                Yes, there are many online calculators that can help you calculate the Gregorian age accurately. Simply input your birthdate into these calculators, and they will provide the age based on the Gregorian calendar.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>What are the uses of the Gregorian age calculation?</h3>
              </div>
              <div className="info-section-body">
                Calculating the Gregorian age is used in various contexts such as reflecting on personal life experience, for future planning, and for setting personal goals. It is also important in areas like insurance, retirement, and healthcare.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>Can the Gregorian age be calculated manually?</h3>
              </div>
              <div className="info-section-body">
                Yes, the Gregorian age can be calculated manually using recognized Gregorian calendar rules. Start by determining the number of years between the birthdate and the current date, and then consider the months and days to get the age in detail.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: '16px' }}>What is the difference between the Gregorian age and the common age?</h3>
              </div>
              <div className="info-section-body">
                The Gregorian age is based on a person's birthdate and the Gregorian calendar, whereas the common age is based solely on years without considering days and months. The Gregorian age provides a precise view of the actual age.
              </div>
            </div>
          </div>
        </div>
      </div> <br />
    </div>
  );
}
export default AgeCalculatorGregorian;
